export default __webpack_public_path__ + "static/media/allow-c6-7.a5deaa89.png";